export const postOpInstructions = {

  all: [

    "Seguir las indicaciones del odontólogo"

  ],

  extraccion: [

    "No escupir durante 24 horas",

    "No fumar durante 72 horas",

    "Aplicar hielo 15 min sí / 15 min no",

    "Dieta blanda"

  ],

  cirugia: [

    "Aplicar hielo durante 48 horas",

    "No realizar ejercicio intenso",

    "Dieta blanda",

    "No fumar"

  ],

  endodoncia: [

    "Evitar masticar del lado tratado",

    "Tomar la medicación prescrita",

    "Acudir a la siguiente cita"

  ],

  tercerMolar: [

    "Aplicar hielo durante 48 horas",

    "No usar popote",

    "No fumar",

    "Dieta blanda"

  ],

  absceso: [

    "Tomar el antibiótico completo",

    "Mantener higiene oral adecuada",

    "Acudir a revisión"

  ],

  periodoncia: [

    "Cepillado suave",

    "Uso de enjuague indicado",

    "No fumar"

  ],

  implante: [

    "Aplicar hielo durante 48 horas",

    "No fumar",

    "Dieta blanda",

    "No manipular la zona"

  ]

};